export default "__VITE_ASSET__5cc80518__"